import React from 'react'
import { Grid, Typography, Link } from '@material-ui/core/'
import { useSession } from '../../hooks/useSession'
import patreonLogo from '../../assetss/img/patreonLogo.svg'
import closeModalIcon from '../../assetss/img/closeModalIcon.svg'
import './index.scss'

const PatreonFooter = ({ setSession }) => {
  const { saveSession } = useSession()

  const updateSessionHandler = () => {
    saveSession(true)
    setSession(true)
  }

  return (
    <Grid className='container'>
      <Grid className='wrapper'>
        <img className='patreonLogo' src={patreonLogo} alt='logo' />

        <Grid className='descriptionBlock'>
          <Grid className='textPatreon'>
            <img className='patreonLogo' src={patreonLogo} alt='logo' />
            Hey! Did you know that we have a Patreon? Join us to receive various perks and have access to exclusive content.
          </Grid>

          <Grid className='linkBox'>
            <Link
              href='https://www.patreon.com/tellme_place?fan_landing=true'
              className='linkPatreon'
              target='_blank'
            >
              Go to Patreon
            </Link>

            <Typography
              onClick={updateSessionHandler}
              className='disabledPatreon'
            >
              No, thanks
            </Typography>
          </Grid>
        </Grid>

        <img
          onClick={updateSessionHandler}
          className='closeIcon'
          src={closeModalIcon}
          alt='closeIcon'
        />
      </Grid>
    </Grid>
  )
}

export default PatreonFooter
